"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "useStopWatchBasic", {
  enumerable: true,
  get: function get() {
    return _useStopWatch["default"];
  }
});
Object.defineProperty(exports, "useStopWatchCountDown", {
  enumerable: true,
  get: function get() {
    return _useStopWatch4["default"];
  }
});
Object.defineProperty(exports, "useStopWatchInterval", {
  enumerable: true,
  get: function get() {
    return _useStopWatch2["default"];
  }
});
Object.defineProperty(exports, "useStopWatchWorker", {
  enumerable: true,
  get: function get() {
    return _useStopWatch3["default"];
  }
});

var _useStopWatch = _interopRequireDefault(require("./Basic/useStopWatch"));

var _useStopWatch2 = _interopRequireDefault(require("./Interval/useStopWatch"));

var _useStopWatch3 = _interopRequireDefault(require("./Worker/useStopWatch"));

var _useStopWatch4 = _interopRequireDefault(require("./CountDown/useStopWatch"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/global-components-library/dist/components/StopWatch/index.js
// module id = 1924
// module chunks = 0